var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "el-select",
        {
          attrs: { filterable: "" },
          on: { change: _vm.updateCurrency },
          model: {
            value: _vm.currency,
            callback: function($$v) {
              _vm.currency = $$v
            },
            expression: "currency"
          }
        },
        _vm._l(_vm.currenciesAvailable, function(currency) {
          return _c(
            "el-option-group",
            { key: currency.label },
            _vm._l(currency.options, function(option) {
              return _c(
                "el-option",
                {
                  key: option.id,
                  attrs: { label: option[_vm.mode], value: option.name }
                },
                [
                  _c("span", { staticClass: "fleft" }, [
                    _vm._v(_vm._s(option.longname))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fright fs-3 gray-60" }, [
                    _vm._v(_vm._s(option.symbol))
                  ])
                ]
              )
            }),
            1
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }